import { z } from 'zod'

export const ResendTwoFactorEmailSetupDTO = z.object({
  setup_challenge_id: z.string().uuid()
})

export type ResendTwoFactorEmailSetupDTO = z.infer<typeof ResendTwoFactorEmailSetupDTO>

export function mapResendTwoFactorEmailSetupToDTO (
  setupChallengeId: string
): ResendTwoFactorEmailSetupDTO {
  return {
    setup_challenge_id: setupChallengeId
  }
}
